import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { createUrl, post } from "../../../network/AxiosInterceptor";
import { AllTripsView } from "./AllTripView";
import { mapToTripKeyInfoViewModel } from "./TripKeyInfoViewModel";

export const AllTripsContainer = () => {
  const [trips, setTrips] = useState([]);

  useEffect(() => {
    fetchAllTrips();
  }, []);

  const fetchAllTrips = async () => {
    post(createUrl(`/api/trips/getTripKeyInfoList`), {})
      .then((response) => {
        setTrips(mapToTripKeyInfoViewModel(response.data.trips))
      })
      .catch(function (error) {
        console.log(error)
      });
  };

  return (
    <AllTripsView
      trips={trips}
    />
  );
};
